export default __webpack_public_path__ + "static/media/3.2bebf1a1.jpeg";